import React from 'react';
import { MapPin, Calendar, Users, Star, Car, ArrowRight } from 'lucide-react';
import { RIDES } from '../data/mockData';
import { toast } from 'sonner';

export default function Rides() {
  const [from, setFrom] = React.useState('');
  const [to, setTo] = React.useState('');

  const filtered = RIDES.filter((r) =>
    (from === '' || r.from.toLowerCase().includes(from.toLowerCase())) &&
    (to === '' || r.to.toLowerCase().includes(to.toLowerCase()))
  );

  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-10 py-14" data-testid="page-rides">
      <div className="grid lg:grid-cols-12 gap-10 items-end mb-10">
        <div className="lg:col-span-7">
          <div className="font-mono text-xs uppercase tracking-widest text-[#ff2a2a] mb-2">Ride Share · Paid commute</div>
          <h1 className="font-display text-4xl sm:text-5xl uppercase tracking-tight leading-none">Trust-based rides. Zero randos.</h1>
          <p className="mt-3 text-zinc-400 text-sm max-w-lg">Every driver is a verified enthusiast. Share fuel. Split tolls. Talk cars the whole way. Inquiries are always free — the ride itself is the paid commute.</p>
        </div>
        <div className="lg:col-span-5 am-card p-4 grid grid-cols-2 gap-3">
          <input
            data-testid="rides-from"
            placeholder="From"
            value={from}
            onChange={(e) => setFrom(e.target.value)}
            className="bg-[#0d0d0d] hairline px-3 py-2.5 text-sm placeholder:text-zinc-600 focus:outline-none focus:border-[#ff2a2a]"
          />
          <input
            data-testid="rides-to"
            placeholder="To"
            value={to}
            onChange={(e) => setTo(e.target.value)}
            className="bg-[#0d0d0d] hairline px-3 py-2.5 text-sm placeholder:text-zinc-600 focus:outline-none focus:border-[#ff2a2a]"
          />
        </div>
      </div>

      <div className="space-y-3" data-testid="rides-list">
        {filtered.map((r) => (
          <article key={r.id} className="am-card p-5 grid md:grid-cols-12 gap-5 items-center" data-testid={`ride-${r.id}`}>
            <div className="md:col-span-4">
              <div className="flex items-center gap-2 text-sm">
                <span className="text-white font-semibold">{r.from}</span>
                <ArrowRight className="w-4 h-4 text-[#ff2a2a]"/>
                <span className="text-white font-semibold">{r.to}</span>
              </div>
              <div className="mt-2 flex items-center gap-3 text-[10px] font-mono uppercase tracking-widest text-zinc-500">
                <span className="flex items-center gap-1"><Calendar className="w-3 h-3"/>{r.date}</span>
                <span>{r.time}</span>
              </div>
            </div>
            <div className="md:col-span-4 flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#0d0d0d] hairline grid place-items-center font-display text-sm">
                {r.driver.split(' ').map(x => x[0]).join('')}
              </div>
              <div>
                <div className="text-sm text-white font-semibold flex items-center gap-1.5">
                  {r.driver}
                  <span className="flex items-center gap-0.5 text-[10px] text-amber-400"><Star className="w-3 h-3 fill-current"/>{r.rating}</span>
                </div>
                <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 flex items-center gap-1">
                  <Car className="w-3 h-3"/>{r.car} · {r.trips} trips
                </div>
              </div>
            </div>
            <div className="md:col-span-2 text-center">
              <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500">Seats</div>
              <div className="text-white font-semibold flex items-center justify-center gap-1"><Users className="w-4 h-4"/>{r.seats}</div>
            </div>
            <div className="md:col-span-2 text-right">
              <div className="font-display text-2xl text-[#ff2a2a]">${r.price}</div>
              <button
                onClick={() => toast.success(`Ride to ${r.to} requested`)}
                className="mt-1 w-full bg-white hover:bg-zinc-200 text-black text-xs font-semibold py-2 transition-colors"
                data-testid={`ride-request-${r.id}`}
              >
                Request seat
              </button>
            </div>
          </article>
        ))}
        {filtered.length === 0 && (
          <div className="am-card p-16 text-center" data-testid="rides-empty">
            <Car className="w-10 h-10 mx-auto text-zinc-700" />
            <div className="mt-4 font-display text-2xl uppercase tracking-tight text-white">No rides posted yet</div>
            <p className="mt-2 text-zinc-400 text-sm max-w-md mx-auto">
              Ride share is a paid commute. Post the first ride and start earning fuel money from verified enthusiasts.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
